// src/screens/DepositInstructions/DepositInstructionsScreen.js
import React, { useContext } from 'react';
import CountContext from '../../context/CountContext.js';

export default function DepositInstructionsScreen({ onNext, onBack }) {
    const { state } = useContext(CountContext);
    const {
        rolls,
        tipBucket: { coins: tipBucketCoins, bills: tipBucketBills },
        drawerCoins,
        bills,
        thresholds,
        report,
        overage // newly added in context by APPLY_OVERAGE
    } = state;

    // 1) Compute rolls value
    const rollsValue =
        rolls.quarters * 10 +
        rolls.dimes * 5 +
        rolls.nickels * 2 +
        rolls.pennies * 0.5;

    // 2) Total change (floor of coins sum)
    const changeTotal = Math.floor(rollsValue + tipBucketCoins + drawerCoins);

    // 3) Total bills value
    const billsValue =
        bills.ones * 1 +
        bills.fives * 5 +
        bills.tens * 10 +
        bills.twenties * 20 +
        bills.fifties * 50 +
        bills.hundreds * 100;

    // 4) Cash to deposit = changeTotal + (billsValue - starter) - overage
    const depositCash =
        changeTotal + (billsValue - thresholds.starterCash) - state.overage;


    // 5) Tips to set aside = floor(creditTips) + tipBucketBills
    // after:
    const creditTipFloor = Math.floor(report.creditTips);

    // split off the whole‑dollar coins
    const coinWhole = Math.floor(tipBucketCoins);

    // Tips to set aside = floor(creditTips) + tipBucketBills + whole‑dollar coins
    const tipCash = creditTipFloor + tipBucketBills + coinWhole;


    return (
        <div className="p-4 max-w-md mx-auto bg-white rounded-2xl shadow-lg space-y-6">
            <h2 className="text-2xl font-bold text-center">Deposit Instructions</h2>

            <div className="flex justify-between">
                <button onClick={onBack} className="px-4 py-2 bg-gray-300 rounded">
                    Back
                </button>
            </div>

            <div className="grid grid-cols-1 gap-4">
                <button
                    onClick={onNext}
                    className="p-4 bg-indigo-50 hover:bg-indigo-100 rounded-2xl border border-indigo-200 text-left"
                >
                    <div className="text-gray-700">Pull for bank deposit</div>
                    <div className="text-3xl font-semibold">${depositCash.toFixed(2)}</div>
                </button>

                <button
                    onClick={onNext}
                    className="p-4 bg-green-50 hover:bg-green-100 rounded-2xl border border-green-200 text-left"
                >
                    <div className="text-gray-700">Tips to set aside</div>
                    <div className="text-3xl font-semibold">${tipCash.toFixed(2)}</div>
                </button>

            </div>
        </div>
    );
}
